<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap remote-table-wrap">
        <el-table-column
                prop="hasAtta"
                width="30"
                align="center">
            <template slot-scope="scope">
                <span v-show="scope.row.hasAtta==true" >
                            <svg class="icon" aria-hidden="true" style="font-size:24px;color:#888888;">
                                <use xlink:href="#icon-biaoqianshuqianhuixingzhen"></use>
                            </svg>
                </span>
                <span v-show="scope.row.hasAtta==false"></span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="状态"
                align="center">
            <template slot-scope="scope">
                <span>待处理</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="资料是否就绪"
                align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.consultGroupNo.charAt(0)=='D'" :class="[scope.row.readyStatus?'table-status-green':'table-status-red']">{{ scope.row.readyStatus?'是':'否' }}</span>
                <span v-else :class="[scope.row.readyStatus?'table-status-green':'table-status-red']">{{ scope.row.readyStatus?'是':'否' }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="时间是否安排"
                align="center">
            <template slot-scope="scope">
                <span :class="[scope.row.consultTime?'table-status-green':'table-status-red']">{{ scope.row.consultTime?"是":"否" }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="安排会诊"
                :formatter="formatUnixConsultTime"
                align="center"
                width="60">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consultGroupNo"-->
                <!--label="编号"-->
                <!--align="center"-->
                <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <el-table-column
                prop="consulterName"
                label="患者"
                align="center"
                width="100">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consulterGender"-->
                <!--label="性别"-->
                <!--:formatter="sexSelect"-->
                <!--align="center"-->
                <!--width="50">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
                <!--prop="consulterAge"-->
                <!--label="年龄"-->
                <!--align="center"-->
                <!--width="50">-->
        <!--</el-table-column>-->
        <el-table-column
                prop="initHosName"
                label="申请机构"
                show-overflow-tooltip
                align="center"
                width="67">
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                show-overflow-tooltip
                align="center"
                width="67">
        </el-table-column>
        <el-table-column
                prop="initDocName"
                label="申请医生"
                show-overflow-tooltip
                align="center"
                width="67">
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                align="center"
                width="60">
        </el-table-column>
        <el-table-column
                prop="consultGroupType"
                label="申请类型"
                align="center"
                width="100">
        </el-table-column>
        <el-table-column
                prop="hopeHosName"
                label="会诊机构"
                show-overflow-tooltip
                align="center">
            <template slot-scope="scope">
                <span >{{ scope.row.hopeHosName?scope.row.hopeHosName:scope.row.acceptHosName }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="hopeDeptName"
                label="会诊科室"
                show-overflow-tooltip
                align="center"
                show-overflow-tooltip>
            <template slot-scope="scope">
                <span >{{ scope.row.hopeDeptName?scope.row.hopeDeptName:scope.row.acceptDeptName }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="acceptDocName"
                    label="会诊专家"
                align="center"
                show-overflow-tooltip>
            <template slot-scope="scope">
                 <span>{{scope.row.acceptDocName?scope.row.acceptDocName:scope.row.hopeDocName}}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToSheet($index, row)"
                        class="table-btn  ghost-btn">
                    会诊单
                </el-button>
                <el-button
                        size="small"
                        @click="linkToDeal($index, row)"
                        class="table-btn ghost-btn">
                    详情
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { formatUnixTime } from "../../utils/DateFormat.js";
    export default{
        props: ["propsTableData"],
        components:{
        },
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                if(row.createTime){
                    return formatUnixTime(row.createTime, "MM-dd HH:mm");
                }
            },
            formatUnixConsultTime: function (row, column) {//格式化会诊时间
                if(row.consultTime){
                    return formatUnixTime(row.consultTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            linkToSheet: function($index, row){
//                this.$router.push({ name: "remoteSheet", params: { consultId: row.consultId }} );
                this.$router.push({ name: "printRemoteSheet", params: { consultId: row.id ,printDetail:row}})
            },
            linkToDeal: function($index, row){
                switch (row.consultStatus){
                    case '4':
                    case '6':
                        this.$router.push({ name: "remoteEvaluate", params: { consultId: row.id }} );
                        break;
                    case '-1':
                        this.$router.push({ name: "remoteReject", params: { consultId: row.id }} );
                        break;
                    default:
                        if(JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosName.indexOf("宁海")>=0){
                            this.$router.push({ name: "remoteToDeal", params: { consultId: row.id }} );
                        }else{
                            this.$router.push({ name: "remoteEntry", params: { consultId: row.id }} );
                        }
                        break;
                }
            }
        }
    }
</script>
